import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { APDEditForm } from "@/features/apd/APDEditForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function APDEdit() {
  const { id } = useParams();
  const isEdit = window.location.pathname.endsWith("/edit");
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/apd",
            label: "APD",
          },
          {
            label: "Edit",
          },
        ]}
      />
      <H2>Edit APD</H2>
      <APDEditForm id={id} isDisabled={!isEdit} />
    </>
  );
}
